export const NAV_TYPES = {
  admin: 'admin',
  cause: 'cause',
  frontend: 'frontend',
}
